import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import {getRegistersPlus} from '../../../../../services/getRegistersPlus'
import icons from '../../../../../theme/icons.js';
// Component styles
import { Grid, TableRow, TableCell, Divider, Table } from '@material-ui/core';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


class RegistersPlus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoad:true,
            perf:null,
            objective:this.props.objective,
            steps:this.props.steps,
            date:this.props.date,
            node:this.props.node,
            div:<div></div>,
            open: false,
            display:"none",
            divElements:<div></div>,
            openElements: false,
            displayElements:"none"
        };
    }

    componentDidMount() {
        this.processData();
    }

    getFetchs = (objective, date, token, node, user) =>{
        return new Promise((resolve, reject) => {
            var List = []
            var fetches = []
            var getData = getRegistersPlus(objective, node, token, date, user)
            fetches.push(                    
                getData.then( data =>  { 
                    List.push(data)
                })                    
            )
            Promise.all(fetches).then(() => {
                resolve(List);
            })      
        });
    }

   
    processData = () => {
        const { objective, steps, date, node}=this.state
        let token = sessionStorage.getItem('key')
        let id_user = sessionStorage.getItem('user')
        var data = this.getFetchs(objective, date.fecha, token, node.id_nodo, id_user)
        var list = []
        data.then( value=>{
            value[0].map(step=>{
                list.push(step)
            })
            this.setState({
                isLoad : false,
                steps : list,
            })
        })
        
        
    }
    handleClose = event => {
        this.setState({
            open: false,
            display:"none"
        })
    };

    handleCloseElements = event => {
        this.setState({
            openElements: false,
            displayElements:"none"
        })
    };
    getStatistics(e, step){
        const {steps}=this.state
        var data=e+""+step.currentTarget.value
        this.setState({
            display:"inline",
            open: true,
            /*div:<PieStatistics data={steps[e]} />*/
        })
    }

    render() {
        const { isLoad, steps} = this.state;

        if (isLoad === true) {
            return(
                <div>
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"
                        size={12}
                        thickness={3}   
                        />
                        Cargando Información...
                    </Typography>
                </div>
            )
        }else{
            return(
                <Table >
                    <TableRow style={{backgroundColor:'gray'}}>
                        <TableCell><Typography style={{color:'white'}}>Paso / IP</Typography> </TableCell>
                        <TableCell><Typography style={{color:'white'}}>Registros</Typography> </TableCell>
                        <TableCell><Typography style={{color:'white'}}>Patrón</Typography>  </TableCell>
                        <TableCell><Typography style={{color:'white'}}>Estado</Typography>  </TableCell>
                        <TableCell><Typography style={{color:'white'}}>Inverso / Obligatorio</Typography> </TableCell>
                    </TableRow>
                    {Object.keys(steps).map((key) => { 
                        return  <TableRow style={{backgroundColor:'white'}}>
                                    <TableCell style={{minWidth:'150px'}}> 
                                        <Typography >{steps[key].nombre}</Typography>
                                        <Typography >{steps[key].ip != "" && steps[key].ip != -1 ? steps[key].ip :'IP no encontrada'}</Typography>
                                    </TableCell>
                                    <TableCell style={{minWidth:'150px'}}> <Typography>{steps[key].registros[0] ? steps[key].registros[0]['@nombre'] : ' '}</Typography></TableCell>
                                    <TableCell style={{minWidth:'150px'}}> <Typography>{steps[key].patrones[0]['@nombre']}</Typography> </TableCell>
                                    {steps[key].estado === '0' ?
                                        <Tooltip title="OK" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.spriteOK}}  /></TableCell></Tooltip>                                 
                                    : steps[key].estado === '27' ?
                                        <Tooltip title="Timeout javascript" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.spriteTIMEOUT_JS}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '13' ?
                                        <Tooltip title="Error de contenido" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.spriteERROR_CONTENIDO}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '1006' ?
                                        <Tooltip title="Timeout de la operación del socket" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.spriteTIMEOUT_DE_LA_OPERACION_DEL_SOCKET}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '3' ?
                                        <Tooltip title="Timeout" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.sprite_TIMEOUT}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '500' ?
                                        <Tooltip title="Error 500" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.sprite500}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '613' ?
                                        <Tooltip title="Error de contenido" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.spriteERROR_CONTENIDO}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '603' ?
                                        <Tooltip title="Troncal ocupado" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.spriteTRONCAL_OCUPADO}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '610' ?
                                        <Tooltip title="Llamada colgada" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.spriteLLAMADA_COLGADA}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '999999' ?
                                        <Tooltip title="Error desconocido en script" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.spriteERROR_DESCONOCIDO_EN_SCRIPT}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '607' ?
                                        <Tooltip title="Timeout" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.sprite_TIMEOUT}}  /></TableCell></Tooltip>
                                    : steps[key].estado === '601' ?
                                        <Tooltip title="Troncal congestionado" placement="left"><TableCell style={{backgroundColor:"white", textAlign:'center'}}><i style={{...icons.sprite, ...icons.spriteTRONCAL_CONGESTIONADO}}  /></TableCell></Tooltip>
                                    : <Tooltip title="Periodo sin monitoreo" placement="left"><TableCell style={{backgroundColor:"white"}}><i style={{...icons.sprite, ...icons.spriteNO_MONITOREO}}/></TableCell></Tooltip>}
                                    <TableCell style={{minWidth:'150px'}}>
                                        <Typography>{steps[key].patrones[0]['@es_inverso'] == 0 ? 'No /': 'Si /'}</Typography>
                                        <Typography>{steps[key].patrones[0]['@es_opcional']  == 0 ? 'Si': 'No'}</Typography> 
                                    </TableCell>
                                </TableRow>
                    })}
                </Table>
            )
        }
        
        
    }
}



export default compose(withRouter, withStyles(styles))(RegistersPlus);